import React from 'react';
import { PropTypes } from 'prop-types';
import { showImyTreeWithholding, updateStatementRow, deleteStatementRow } from 'actions';
import FormTypes from 'common/Forms/FormTypes';
import StatementTypes from 'common/Forms/StatementTypes';
import LOBCodes from 'common/Customers/LimitationOnBenefits';
import ValidationInspector from 'common/Validation/ValidationInspector';
import valueOrEmpty from 'common/App/valueOrEmpty';
import AccessControl from 'components/AccessControl';
import ActivityPerms from 'components/AccessControl/permissions.json';
import { FormViewButton } from 'components/Common/Buttons/FormViewButton';
import Chapter3Status from 'common/Customers/Chapter3Status';
import Chapter4Status from 'common/Customers/Chapter4Status';
import WhdValidationSummary from 'components/WhdStatement/WhdValidationSummary';
import JurisdictionDropDown from 'components/Common/Inputs/JurisdictionDropDown';
import ConfirmModal from 'components/Modals/ConfirmModal';
import removeInvalidHtmlChars from 'common/App/removeInvalidHtmlChars';

class BeneficialOwner extends React.PureComponent {
  static propTypes = {
    beneficialOwner: PropTypes.shape({
      basicDetails: PropTypes.shape({}),
      recipients: PropTypes.arrayOf(PropTypes.shape({ allocationIncomeRate: PropTypes.number, validationLineNo: PropTypes.number })),
      guid: PropTypes.string,
      ownerDetails: PropTypes.shape({
        name: PropTypes.string,
        guid: PropTypes.string,
        accountNumber: PropTypes.string,
        disregardedEntityName: PropTypes.string,
        foreignTIN: PropTypes.string,
        giin: PropTypes.string,
        tin: PropTypes.string,
        active: PropTypes.string,
        address: PropTypes.string,
        allocationIncomeRate: PropTypes.number,
        chapter3RecipientCode: PropTypes.string,
        city: PropTypes.string,
        country: PropTypes.string,
        decimalPrecision: PropTypes.number,
        fatcaStatus: PropTypes.string,
        formType: PropTypes.number,
        limitationOnBenefits: PropTypes.number,
        new: PropTypes.string,
        stateProvince: PropTypes.string,
        taxResidenceCountry: PropTypes.string,
        tinType: PropTypes.string,
        treatyBenefits: PropTypes.string,
        usNonUsStatus: PropTypes.string,
        zip: PropTypes.string,
        isTier: PropTypes.bool,
      }),
      statementIndex: PropTypes.number
    }).isRequired,
    decimalPrecision: PropTypes.number,
    getChapter3DescriptionByName: PropTypes.func.isRequired,
    getChapter4DescriptionByName: PropTypes.func.isRequired,
    isParentTierExpanded: PropTypes.bool,
    isTopTierExpanded: PropTypes.bool,
    openChangeParentModal: PropTypes.func.isRequired,
    parents: PropTypes.arrayOf(PropTypes.string),
    statementType: PropTypes.number,
    idx: PropTypes.number.isRequired,
    permissions: PropTypes.arrayOf(PropTypes.string),
    dispatch: PropTypes.func.isRequired,
    openAccountWithholdingModal: PropTypes.func.isRequired,
    openAddFormModal: PropTypes.func.isRequired,
    topAccountId: PropTypes.number.isRequired,
    addBeneficialOwner: PropTypes.func.isRequired,
    isSavingStatement: PropTypes.bool,
    validationLineNo: PropTypes.number,
    validationResult: PropTypes.shape({
      valid: PropTypes.bool,
      rejections: PropTypes.arrayOf(PropTypes.shape({ code: PropTypes.string })),
      warnings: PropTypes.arrayOf(PropTypes.shape({ code: PropTypes.string })),
      lines: PropTypes.arrayOf(PropTypes.shape({}))
    }),
    openPooledRatesModal: PropTypes.func.isRequired,
    updateToggledCollapsibleTiers: PropTypes.func.isRequired,
    tierCollapseStructure: PropTypes.shape({}),
    // eslint-disable-next-line react/no-unused-prop-types
    parentAccountId: PropTypes.number,
    isDeletingRow: PropTypes.bool,
    isStructureValid: PropTypes.bool,
    isAddingNewBeneficalOwner: PropTypes.bool,
    statementVersion: PropTypes.string,
    parentTierTotalAllocation: PropTypes.number,
    hideTierAllocationValue: PropTypes.bool
  };

  static defaultProps = {
    parents: null,
    decimalPrecision: 2,
    isParentTierExpanded: false,
    isTopTierExpanded: false,
    statementType: 9,
    permissions: null,
    isSavingStatement: false,
    validationResult: null,
    validationLineNo: null,
    tierCollapseStructure: null,
    isDeletingRow: false,
    isStructureValid: false,
    parentAccountId: null,
    isAddingNewBeneficalOwner: false,
    statementVersion: null,
    parentTierTotalAllocation: 0,
    hideTierAllocationValue: false
  };

  static buildElementId(name) {
    return (name && name.replace(/[^a-zA-Z0-9]/g, '')) || '';
  }

  static isAllocationFromChildren(beneficialOwner) {
    const allocation = (beneficialOwner.ownerDetails && beneficialOwner.ownerDetails.allocationIncomeRate) || beneficialOwner.allocationIncomeRate || 0;

    if (allocation === 0 && beneficialOwner.recipients) {
      return true;
    }

    return false;
  }

  static shouldDisplayTierAllocationValue(beneficialOwner) {
    const allocation = (beneficialOwner.ownerDetails && beneficialOwner.ownerDetails.allocationIncomeRate) || beneficialOwner.allocationIncomeRate || 0;
    if (allocation === 0 && beneficialOwner.recipients && BeneficialOwner.getAllocationValue(beneficialOwner) === 0) {
      return false;
    }
    return true;
  }

  constructor(props) {
    super(props);
    this.state = {
      toggleState: {
        isAdditionalExpanded: false,
        isOverrideTopTier: false,
        isTierExpanded: false,
      },
      isEdit: false,
      rowToDelete: null,
      details: {
        accountName: null,
        name: null,
        disregardedEntityName: null,
        giin: null,
        tin: null,
        foreignTin: null,
        taxResidenceCountry: null,
        fatcaStatus: null,
        chapter3RecipientCode: null,
        usNonUsStatus: null,
        address: null,
        city: null,
        stateProvince: null,
        zip: null,
        country: null,
        new: false,
        active: false,
        tinType: null,
        limitationOnBenefits: null,
        treatyBenefits: null,
        allocationIncomeRate: 0,
        accountNumber: null,
        formType: null,
        allocationFromChildren: false,
        isTier: null
      },
      checkboxState: {
        formsDisableImyCheckbox: false,
        allocDisablesImyCheckbox: false,
        formsDisableOwnerCheckbox: false,
      }
    };
  }

  componentDidMount() {
    this.setExpandedTiers();
    this.setFieldStates();
  }

  componentDidUpdate(oldProps) {
    const { isTopTierExpanded, beneficialOwner, statementType, isDeletingRow, tierCollapseStructure } = this.props;
    const isPooled = statementType === StatementTypes.PooledWhdStatement;
    const ownerDetails = isPooled ? beneficialOwner : beneficialOwner.ownerDetails;
    const rowIdentifier = ownerDetails.guid || ownerDetails.name || ownerDetails.accountName;

    if (oldProps && oldProps.isTopTierExpanded !== isTopTierExpanded) {
      this.resetOverrideTopTierCollapse(rowIdentifier, isTopTierExpanded);
    }

    if (oldProps && oldProps.isDeletingRow && !isDeletingRow) {
      this.closeDeleteConfirmation();
    }

    if (oldProps && JSON.stringify(oldProps.tierCollapseStructure) !== JSON.stringify(tierCollapseStructure)) {
      if (tierCollapseStructure[rowIdentifier] != null) {
        this.setExpandedTiers();
      }
    }
  }

  static getLOBDescriptionByCode = (code) => {
    const codeValue = (code && parseInt(code, 10)) || null;
    const item = code && codeValue > 0 && LOBCodes.find(x => x.value === codeValue);
    return (codeValue && `${ codeValue < 10 ? '0' : '' }${ codeValue } - ${ (item && item.description) || 'Unknown code' }`) || code || null;
  };

  static getAllocationTitle() {
    return 'WHS Allocation';
  }

  static getAllocationValue(beneficialOwner) {
    const allocation = (beneficialOwner.ownerDetails && beneficialOwner.ownerDetails.allocationIncomeRate) || beneficialOwner.allocationIncomeRate || 0;

    if (allocation === 0 && beneficialOwner.recipients) {
      return beneficialOwner.recipients.reduce((prev, curr) => prev + (BeneficialOwner.getAllocationValue(curr) || 0), 0);
    }

    return allocation * 100;
  }

  static getTierAllocationTitle(beneficialOwner) {
    const allocation = (beneficialOwner.ownerDetails && beneficialOwner.ownerDetails.allocationIncomeRate) || 0;
    return allocation === 0 && beneficialOwner.recipients ? 'Tier Total' : 'Tier Allocation';
  }

  static getTierAllocationValue(beneficialOwner, parentTierTotalAllocation) {
    if (beneficialOwner.ownerDetails && !beneficialOwner.ownerDetails.allocationIncomeRate && beneficialOwner.recipients) {
      return 100;
    }
    const allocationValueOfBeneficialOwner = BeneficialOwner.getAllocationValue(beneficialOwner);
    if (parentTierTotalAllocation) {
      return (allocationValueOfBeneficialOwner / parentTierTotalAllocation) * 100;
    }
    return allocationValueOfBeneficialOwner;
  }

  onNameChange(value) {
    const { statementType } = this.props;
    const { details } = this.state;
    const isPooled = statementType === StatementTypes.PooledWhdStatement;
    if (isPooled) {
      this.setState({ details: { ...details, accountName: value } });
    } else {
      this.setState({ details: { ...details, name: value } });
    }
  }

  setExpandedTiers() {
    const { tierCollapseStructure, beneficialOwner, statementType } = this.props;

    const isPooled = statementType === StatementTypes.PooledWhdStatement;
    const ownerDetails = isPooled ? beneficialOwner : beneficialOwner.ownerDetails;
    const name = ownerDetails.guid || ownerDetails.name || ownerDetails.accountName;
    const toggleState = tierCollapseStructure && tierCollapseStructure[name];
    if (toggleState) {
      toggleState.isOverrideTopTier = true;
      this.setState({ toggleState });
    }
  }

  setFieldStates() {
    const { statementType, beneficialOwner } = this.props;
    const { details, checkboxState } = this.state;

    const isPooled = statementType === StatementTypes.PooledWhdStatement;
    const isDetailed = statementType === StatementTypes.DetailedWhdStatement;
    const isSimple = statementType === StatementTypes.SimpleWhdStatement;
    const isAlt = statementType === StatementTypes.AltWhdStatement;

    const ownerDetails = Object.assign(isPooled ? beneficialOwner : beneficialOwner.ownerDetails, {});
    const name = ownerDetails.name || ownerDetails.accountName;
    const chapter3Item = Chapter3Status.findByName(ownerDetails.chapter3RecipientCode);
    const chapter4Item = Chapter4Status.findByName(ownerDetails.fatcaStatus);
    const allocationValue = BeneficialOwner.getAllocationValue(beneficialOwner);

    details.chapter3RecipientCode = (chapter3Item && chapter3Item.name) || null;
    details.fatcaStatus = (chapter4Item && chapter4Item.name) || null;
    details.allocationIncomeRate = allocationValue ? allocationValue * 1 : null;
    details.allocationFromChildren = BeneficialOwner.isAllocationFromChildren(beneficialOwner);

    if (isPooled) {
      details.accountName = name;
    }

    if (!isPooled) {
      details.name = name;
      details.disregardedEntityName = ownerDetails.disregardedEntityName;
      details.giin = ownerDetails.giin;
      details.isTier = ownerDetails.isTier;

      if (isDetailed || isSimple) {
        details.tin = ownerDetails.tin;
        details.foreignTin = ownerDetails.foreignTIN;
        details.address = ownerDetails.address;
      }
      if (isDetailed || isSimple || isAlt) {
        details.taxResidenceCountry = ownerDetails.taxResidenceCountry;
      }

      if (isDetailed || isSimple || isPooled) {
        details.usNonUsStatus = ownerDetails.usNonUsStatus;
      }

      if (isDetailed) {
        details.city = ownerDetails.city;
        details.stateProvince = ownerDetails.stateProvince;
        details.zip = ownerDetails.zip;
        details.country = ownerDetails.country;
        details.new = ownerDetails.new;
        details.active = ownerDetails.active;
        details.tinType = ownerDetails.tinType;
        details.treatyBenefits = ownerDetails.treatyBenefits;
        details.limitationOnBenefits = ownerDetails.limitationOnBenefits;
        details.accountNumber = ownerDetails.accountNumber;
        details.formType = ownerDetails.formType;
      }

      const formInt = details.formType && parseInt(details.formType, 10);
      const detailsFormType = formInt && FormTypes.getByValue(formInt);

      checkboxState.formsDisableImyCheckbox = !!(detailsFormType && detailsFormType.family !== 'w8imy');
      checkboxState.allocDisablesImyCheckbox = !details.allocationFromChildren && !!details.allocationIncomeRate;
      checkboxState.formsDisableOwnerCheckbox = !!(detailsFormType && detailsFormType.family === 'w8imy');
    }

    this.setState({ details, checkboxState });
  }

  getTierRecipientCount() {
    const { beneficialOwner } = this.props;
    return beneficialOwner?.recipients ? beneficialOwner?.recipients.filter(r => !r.recipients).length : 0;
  }

  getTierIntermediaryCount() {
    const { beneficialOwner } = this.props;
    return beneficialOwner?.recipients ? beneficialOwner?.recipients.filter(r => r.recipients).length : 0;
  }

  ownerHasValidationErrors = (recipient) => {
    const { validationResult } = this.props;

    if (!validationResult?.lines || validationResult.lines.length === 0) {
      return false;
    }

    const lineNo = recipient && (recipient.lineNo || (recipient.ownerDetails && recipient.ownerDetails.lineNo > 0 && recipient.ownerDetails.lineNo));
    const lineValidation = lineNo > 0 && validationResult.lines.find(result => result.lineNumber === lineNo);

    return lineNo > 0
      && (ValidationInspector.hasRejections(lineValidation)
        || ValidationInspector.hasWarnings(lineValidation));
  };

  tierHasValidationErrors = () => {
    const { beneficialOwner, validationResult } = this.props;
    if (!beneficialOwner.recipients || !validationResult?.lines || validationResult.lines.length === 0) {
      return false;
    }

    if (this.ownerHasValidationErrors(beneficialOwner)) {
      return true;
    }

    // This filter ensures only direct owners and not sub-layers are checked
    return beneficialOwner.recipients.some(recipient => recipient
      && !Object.prototype.hasOwnProperty.call(recipient, 'recipients')
      && this.ownerHasValidationErrors(recipient));
  };

  toggleExpandedAdditionalDetails = () => {
    const { updateToggledCollapsibleTiers, beneficialOwner, statementType } = this.props;
    const { toggleState } = this.state;
    const isPooled = statementType === StatementTypes.PooledWhdStatement;
    const ownerDetails = isPooled ? beneficialOwner : beneficialOwner.ownerDetails;
    const rowIdentifier = ownerDetails.guid || ownerDetails.name || ownerDetails.accountName;

    toggleState.isAdditionalExpanded = !toggleState.isAdditionalExpanded;
    this.setState({ toggleState });
    updateToggledCollapsibleTiers(rowIdentifier, toggleState);
  };

  toggleCollapseTier = () => {
    const { isTopTierExpanded, updateToggledCollapsibleTiers, beneficialOwner, statementType } = this.props;
    const { toggleState } = this.state;

    const { isTierExpanded, isOverrideTopTier } = toggleState;
    const isPooled = statementType === StatementTypes.PooledWhdStatement;
    const ownerDetails = isPooled ? beneficialOwner : beneficialOwner.ownerDetails;
    const rowIdentifier = ownerDetails.guid || ownerDetails.name || ownerDetails.accountName;

    if (!isOverrideTopTier) {
      toggleState.isOverrideTopTier = true;
      toggleState.isTierExpanded = !isTopTierExpanded;
    } else {
      toggleState.isTierExpanded = !isTierExpanded;
    }

    this.setState({ toggleState });
    updateToggledCollapsibleTiers(rowIdentifier, toggleState);
  };

  displayImy = (formaccountId, versionNumber) => {
    const { dispatch } = this.props;
    dispatch(showImyTreeWithholding(formaccountId, versionNumber));
  };

  onIncomeAllocationChange = (e) => {
    const { details, checkboxState } = this.state;
    const result = this.getImyCheckboxState(null, e.target.value, true);

    if (e.target.value >= 0 && e.target.value <= 100) {
      this.setState({
        details: { ...details,
          allocationIncomeRate: e.target.value,
          isTier: result[0] },
        checkboxState: {
          ...checkboxState,
          allocDisablesImyCheckbox: result[2],
        } });
    }
  };

  addOwner = (topAccountId, parentGuid, isLayer) => {
    const { addBeneficialOwner, updateToggledCollapsibleTiers } = this.props;
    const { toggleState } = this.state;
    if (!toggleState.isOverrideTopTier) {
      toggleState.isOverrideTopTier = true;
    }

    toggleState.isTierExpanded = true;
    this.setState({ toggleState });
    updateToggledCollapsibleTiers(parentGuid, toggleState);

    const preventExpand = true;
    addBeneficialOwner(topAccountId, parentGuid, isLayer, preventExpand);
  };

  // eslint-disable-next-line class-methods-use-this
  doesCh3AllowAllocationChange = (ch3Name, boRecipients) => {
    if (ch3Name && (!boRecipients || boRecipients.length === 0)) {
      const chapter3Item = Chapter3Status.findByName(ch3Name);
      if (chapter3Item && chapter3Item.value) {
        const allowedCh3Elections = [3, 5, 9, 11, 12, 35, 39];

        if (allowedCh3Elections.includes(chapter3Item.value)) {
          return true;
        }
      }
    }
    return false;
  };

  doesCh3AllowImyCheckbox = (ch3Code) => {
    const { details } = this.state;
    const codeToUse = ch3Code || details.chapter3RecipientCode;

    if (codeToUse) {
      const ch3Election = Chapter3Status.findByName(codeToUse);
      if (ch3Election && ch3Election.value) {
        const allowedCh3Elections = [8, 10];

        if (allowedCh3Elections.includes(ch3Election.value)) {
          return true;
        }
      }
    }
    return false;
  };

  getImyCheckboxState = (formType, allocation, allocationChanged) => {
    const { details } = this.state;
    let isTier;

    const formTypeFamily = formType ? FormTypes.getByValue(formType) : details.formType && FormTypes.getByValue(details.formType);

    const imyCheckBoxResult = this.getImyCheckboxSettings(formTypeFamily, allocation, allocationChanged);

    const formsDisableImyCheckbox = imyCheckBoxResult[0];
    const allocDisablesImyCheckbox = imyCheckBoxResult[1];

    if (formsDisableImyCheckbox || allocDisablesImyCheckbox) {
      isTier = false;
    }

    const formsDisableOwnerCheckbox = this.getOwnerCheckboxSettings(formTypeFamily);

    if (formsDisableOwnerCheckbox) {
      isTier = true;
    }

    return [isTier, formsDisableImyCheckbox, allocDisablesImyCheckbox, formsDisableOwnerCheckbox];
  };

  // eslint-disable-next-line class-methods-use-this
  getOwnerCheckboxSettings = formTypeFamily => !!(formTypeFamily && formTypeFamily.family === 'w8imy');

  getImyCheckboxSettings = (formTypeFamily, allocation, allocationChanged) => {
    const { details } = this.state;
    const formsDisableImyCheckbox = !!(formTypeFamily && formTypeFamily.family !== 'w8imy');
    const allocDisablesImyCheckbox = allocationChanged ? !!allocation : !!details.allocationIncomeRate;

    return [formsDisableImyCheckbox, allocDisablesImyCheckbox];
  };

  onFormTypeChange = (e) => {
    const { details, checkboxState } = this.state;
    const formType = parseInt(e.target.value, 10);

    const intermediaryCheckboxResult = this.getImyCheckboxState(formType, null);

    this.setState({
      details: { ...details,
        formType,
        isTier: intermediaryCheckboxResult[0],
      },
      checkboxState: { ...checkboxState,
        formsDisableImyCheckbox: intermediaryCheckboxResult[1],
        formsDisableOwnerCheckbox: intermediaryCheckboxResult[3] } });
  };

  onCh3Change = (e) => {
    const { details } = this.state;
    const ch3Result = this.doesCh3AllowImyCheckbox(e.target.value);
    const clearIsTier = !ch3Result;

    this.setState({ details: { ...details,
      chapter3RecipientCode: (e.target.value && Chapter3Status.findByName(e.target.value).name) || '',
      isTier: clearIsTier ? null : details.isTier
    } });
  };

  submitData() {
    const { beneficialOwner, statementType, topAccountId, dispatch, decimalPrecision } = this.props;
    const { details, isEdit } = this.state;

    const isPooled = statementType === StatementTypes.PooledWhdStatement;

    const ownerDetails = isPooled ? beneficialOwner : beneficialOwner.ownerDetails;
    const currentAccountName = ownerDetails.name || ownerDetails.accountName;
    const boCopy = Object.assign(isPooled ? beneficialOwner : beneficialOwner.ownerDetails);
    const updatedObject = Object.assign(boCopy, details);

    let allocationRate = details.allocationIncomeRate ? details.allocationIncomeRate / 100 : null;
    if (allocationRate) {
      allocationRate = parseFloat(allocationRate.toFixed(2 + (decimalPrecision ?? 2)));
      details.allocationIncomeRate = (allocationRate * 100).toString();
    }

    const ch3AllowsAllocationChange = this.doesCh3AllowAllocationChange(details.chapter3RecipientCode, beneficialOwner.recipients);

    if (ch3AllowsAllocationChange) {
      updatedObject.allocationIncomeRate = allocationRate;
    } else if (details.allocationFromChildren) {
      updatedObject.allocationIncomeRate = null;
    } else {
      updatedObject.allocationIncomeRate = allocationRate;
    }

    const rowUpdate = {
      guid: ownerDetails.guid,
      name: currentAccountName,
      type: statementType,
      owner: !isPooled ? updatedObject : null,
      account: isPooled ? updatedObject : null
    };

    dispatch(updateStatementRow(topAccountId, rowUpdate));
    this.setState({ isEdit: !isEdit, details });
  }

  resetOverrideTopTierCollapse(rowIdentifier, isTopExpanded) {
    const { updateToggledCollapsibleTiers } = this.props;
    const { toggleState } = this.state;
    toggleState.isTierExpanded = isTopExpanded;
    toggleState.isOverrideTopTier = false;
    this.setState({ toggleState });
    updateToggledCollapsibleTiers(rowIdentifier, toggleState);
  }

  displayAllocationValue(beneficialOwner) {
    const { decimalPrecision } = this.props;
    const allocation = BeneficialOwner.getAllocationValue(beneficialOwner);

    if (allocation === 100) {
      return allocation;
    }

    return allocation.toFixed(decimalPrecision);
  }

  displayTierAllocationValue(beneficialOwner, parentTierTotalAllocation) {
    const { decimalPrecision } = this.props;
    const allocation = BeneficialOwner.getTierAllocationValue(beneficialOwner, parentTierTotalAllocation);

    if (allocation === 100) {
      return allocation;
    }

    return allocation.toFixed(decimalPrecision);
  }

  deleteRow() {
    const { dispatch, topAccountId } = this.props;
    const { rowToDelete } = this.state;
    dispatch(deleteStatementRow(topAccountId, rowToDelete));
  }

  openDeleteConfirmation() {
    const { statementType, beneficialOwner } = this.props;
    const ownerDetails = statementType === StatementTypes.PooledWhdStatement ? beneficialOwner : beneficialOwner.ownerDetails;

    this.setState({ rowToDelete: {
      guid: ownerDetails.guid,
      type: statementType,
    } });
  }

  closeDeleteConfirmation() {
    this.setState({ rowToDelete: null });
  }

  render() {
    const {
      beneficialOwner,
      decimalPrecision,
      getChapter3DescriptionByName,
      getChapter4DescriptionByName,
      idx,
      isParentTierExpanded,
      isTopTierExpanded,
      openChangeParentModal,
      parents,
      statementType,
      permissions,
      dispatch,
      openAccountWithholdingModal,
      openAddFormModal,
      addBeneficialOwner,
      topAccountId,
      isSavingStatement,
      validationResult,
      validationLineNo,
      openPooledRatesModal,
      updateToggledCollapsibleTiers,
      tierCollapseStructure,
      isDeletingRow,
      isStructureValid,
      isAddingNewBeneficalOwner,
      statementVersion,
      parentTierTotalAllocation,
      hideTierAllocationValue
    } = this.props;

    const {
      toggleState: {
        isAdditionalExpanded,
        isTierExpanded,
        isOverrideTopTier
      },
      isEdit,
      rowToDelete,
      details,
      checkboxState,
    } = this.state;

    const isAlt = statementType === StatementTypes.AltWhdStatement;
    const isDetailed = statementType === StatementTypes.DetailedWhdStatement;
    const isSimple = statementType === StatementTypes.SimpleWhdStatement;
    const isPooled = statementType === StatementTypes.PooledWhdStatement;

    const showingVersion = statementVersion !== null && typeof statementVersion !== 'undefined';

    const ownerDetails = isPooled ? beneficialOwner : beneficialOwner.ownerDetails;
    const name = ownerDetails.name || ownerDetails.accountName;
    const detailsName = isPooled ? details.accountName : details.name;
    const levelParents = [...parents];
    const formType = FormTypes.getByValue(ownerDetails.formType);
    const isImyLayer = !!beneficialOwner.recipients || formType === FormTypes.w8imy;
    const allowLayerAllocationChange = this.doesCh3AllowAllocationChange(details.chapter3RecipientCode, beneficialOwner.recipients);

    const isTopTierCollapsed = isImyLayer && !isOverrideTopTier && !isTopTierExpanded;
    const isTierCollapsed = isTopTierCollapsed || (isImyLayer && isOverrideTopTier ? !isTierExpanded : !isParentTierExpanded);
    const validationResultLine = validationResult && validationResult.lines && validationResult.lines.length >= 0 && validationResult.lines.find(result => result.lineNumber === validationLineNo);
    const beneficialOwnerObject = beneficialOwner;

    const hasFormUploaded = beneficialOwnerObject && beneficialOwnerObject.basicDetails && beneficialOwnerObject.basicDetails.formId !== null;
    const ownerFormId = hasFormUploaded && beneficialOwnerObject.basicDetails.formId;
    const ownerAccountId = beneficialOwnerObject.basicDetails && beneficialOwnerObject.basicDetails.accountId;
    const canEdit = AccessControl.hasPermission(permissions, [ActivityPerms.multiTierMgrEditWhs]) && !showingVersion;
    const canUploadPermission = AccessControl.hasPermission(permissions, [ActivityPerms.scannedUpload, ActivityPerms.scannedWhdStmtBoUpload], true);
    const tierRecipients = this.getTierRecipientCount();
    const tierIntermediaries = this.getTierIntermediaryCount();
    const canSetIntermediaryCheckbox = this.doesCh3AllowImyCheckbox();

    const disabledOwnerToolTipText = checkboxState.formsDisableOwnerCheckbox ? 'Beneficiary Owners require W-8BEN-E or W-8ECI forms.' : null;
    const disableIntermediaryCheckbox = !!((checkboxState.formsDisableImyCheckbox || checkboxState.allocDisablesImyCheckbox));
    let disabledIntermediaryToolTipText = null;

    if (checkboxState.formsDisableImyCheckbox) {
      disabledIntermediaryToolTipText = 'To be an Intermediary requires a W8-IMY form.';
    } else if (checkboxState.allocDisablesImyCheckbox) {
      disabledIntermediaryToolTipText = 'Intermediaries cannot have a direct % allocation.';
    }

    const pooledRecipient = beneficialOwner;

    const buildImyTierObject = (item) => {
      if (!item) {
        return null;
      }
      const formObject = {
        accountId: item.accountId,
        accountName: item.name,
        accountNumber: item.accountNumber,
        customerDbId: item.customerDbId,
        customerId: item.customerIdentifier,
        customerName: item.customerName,
      };

      return formObject;
    };

    const buildFormObject = (item) => {
      if (item === undefined) {
        return null;
      }
      const formTypeValue = item && item.formType && FormTypes.getByValue(item.formType);
      const formObject = {
        accountId: item.accountId,
        id: item.formId,
        name: item.name,
        customerDbId: item.customerDbId,
        customerName: item.customerName,
        formId: item.formId,
        formType: formTypeValue && formTypeValue.code,
        workflowStatus: item.workflowStatus,
        workflowUsername: item.workflowUsername ? item.workflowUsername : 'N/A',
        workflowUserFullName: item.workflowUserFullName
      };
      return formObject;
    };

    if (isImyLayer) {
      levelParents.push(name);
    }

    return (isImyLayer || !isTierCollapsed) && <React.Fragment>
      <div id={ !isPooled ? beneficialOwner.ownerDetails.guid : beneficialOwner.guid } className="beneficiary-owner">
        <div className={ `statement-breadcrumbs ${ !isImyLayer ? 'indent' : '' }` }>
          <div className="breadcrumbs">
            /{ levelParents && levelParents.length > 0 && levelParents.map(x => <React.Fragment key={ [...parents, x] }> <span className="breadcrumb-item">{ x }</span> /</React.Fragment>) }
          </div>
          { isImyLayer && !showingVersion && <div className="button-row">
            { canEdit && <button
              type="button"
              onClick={ () => openChangeParentModal(beneficialOwner.ownerDetails.guid, beneficialOwner.basicDetails, idx) }
              className="btn link-button"
            ><span className="icon icon-list-position" />Change Parent</button> }
            <button type="button" onClick={ this.toggleCollapseTier } className="btn link-button"><span className="icon icon-resize-xy" />{ isTierCollapsed ? 'Open' : 'Collapse' } Tier</button>
          </div> }
        </div>
        { isImyLayer && <div className={ `panel mb-2 imy-card${ (this.tierHasValidationErrors() && ' validation-highlight') || '' }` }>
          <div className="columns">
            <div className="col-12">
              <div className="columns imy-layer">
                <div className="col-3 align-vertical-middle">
                  <div className="owner-header"><h2 className="value">{ valueOrEmpty(name) }</h2></div>
                </div>
                <div className="col-3 align-vertical-middle">
                  <div className="owner-header value mr-2">{ tierRecipients } { isPooled ? 'Pooled Account' : 'Beneficial Owner' }{ tierRecipients === 0 || tierRecipients > 1 ? 's' : '' }</div>
                  { !isPooled && <div className="owner-header value">/ { tierIntermediaries } Intermediar{ tierIntermediaries === 0 || tierIntermediaries > 1 ? 'ies' : 'y' }</div> }
                </div>
                <div className="col-2 align-vertical-center">
                  <div className="owner-header value">{ this.displayAllocationValue(beneficialOwner) }% WHS Allocation</div>
                </div>
                <div className="col-4 align-vertical-middle">
                  { !isPooled && hasFormUploaded && canUploadPermission && !showingVersion && <div className="col-4 align-vertical-center">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={ () => openAddFormModal(buildImyTierObject(beneficialOwnerObject.basicDetails)) }
                      data-testid="btn-upload-forms-bo"
                    >
                      <i className="icon icon-2x icon-upload mr-2" />Upload Form(s)
                    </button>
                  </div> }
                  { canEdit && <div className="col-4 align-vertical-center">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      disabled={ isAddingNewBeneficalOwner }
                      onClick={ () => this.addOwner(topAccountId, beneficialOwner.ownerDetails.guid, false) }
                    >
                      <i className="icon icon-2x icon-plus mr-2" />{ isPooled ? 'Add Pool' : 'Add Beneficial Owner' }
                    </button>
                  </div> }
                  { !isPooled && canEdit && <div className="col-4 align-vertical-center">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      disabled={ isAddingNewBeneficalOwner }
                      onClick={ () => this.addOwner(topAccountId, beneficialOwner.ownerDetails.guid, true) }
                    >
                      <i className="icon icon-2x icon-plus mr-2" />Add IMY Tier
                    </button>
                  </div> }
                </div>
              </div>
            </div>
          </div>
        </div> }
        {!isTierCollapsed && <div className={ `panel statement-line-panel${ (this.ownerHasValidationErrors(beneficialOwner) && ' validation-highlight') || '' }` } data-testid={ removeInvalidHtmlChars(`${ levelParents } ${ name }`).toLowerCase() }>
          <div className="columns">
            <div className="col-9">
              <div className="columns">
                <div className="col-6">
                  { (!isImyLayer || allowLayerAllocationChange) && <div className="owner-header"><h2>{ name }</h2></div> }
                </div>
                { isDetailed && <div className="col-6">
                  <div className="owner-uniqueid"><h3>Unique ID: { !isEdit && <span className="value">{ valueOrEmpty(ownerDetails.accountNumber) }</span> }
                    { isEdit && <input type="text" value={ details.accountNumber || '' } onChange={ e => this.setState({ details: { ...details, accountNumber: e.target.value } }) } /> }
                  </h3>
                  </div>
                </div> }
              </div>
              <div className="columns">
                <div className="col-6">
                  <div className="columns">
                    <div className="col-5 panel-item-name">Name</div>
                    { !isEdit && <div className="col-7">{ name }</div> }
                    { isEdit && <input type="text" className=" col-5 form-input" onChange={ e => this.onNameChange(e.target.value) } value={ detailsName || '' } /> }
                    { !isPooled && <React.Fragment>
                      <div className="col-5 panel-item-name">Business (DRE) Name</div>
                      { !isEdit && <div className="col-7">{ valueOrEmpty(ownerDetails.disregardedEntityName) }</div> }
                      { isEdit && <input type="text" className=" col-5 form-input" onChange={ e => this.setState({ details: { ...details, disregardedEntityName: e.target.value } }) } value={ details.disregardedEntityName || '' } /> }
                      <div className="col-5 panel-item-name">GIIN</div>
                      { !isEdit && <div className="col-7">{ valueOrEmpty(ownerDetails.giin) }</div> }
                      { isEdit && <input type="text" className=" col-5 form-input" onChange={ e => this.setState({ details: { ...details, giin: e.target.value } }) } value={ details.giin || '' } /> }
                      { (isDetailed || isSimple) && <React.Fragment>
                        <div className="col-5 panel-item-name">U.S. TIN</div>
                        { !isEdit && <div className="col-7">{ valueOrEmpty(ownerDetails.tin) }</div> }
                        { isEdit && <input type="text" className=" col-5 form-input" onChange={ e => this.setState({ details: { ...details, tin: e.target.value } }) } value={ details.tin || '' } /> }
                        <div className="col-5 panel-item-name">Foreign TIN</div>
                        { !isEdit && <div className="col-7">{ valueOrEmpty(ownerDetails.foreignTIN) }</div> }
                        { isEdit && <input type="text" className=" col-5 form-input" onChange={ e => this.setState({ details: { ...details, foreignTin: e.target.value } }) } value={ details.foreignTin || '' } /> }
                      </React.Fragment> }
                    </React.Fragment> }
                  </div>
                </div>
                <div className="col-6">
                  <div className="columns">
                    { (isDetailed || isSimple || isAlt) && <React.Fragment>
                      <div className="col-5 panel-item-name">Country of Tax Residence</div>
                      { !isEdit && <div className="col-7">{ valueOrEmpty(ownerDetails.taxResidenceCountry) }</div> }
                      { isEdit && <JurisdictionDropDown value={ details.taxResidenceCountry || '' } onChange={ value => this.setState({ details: { ...details, taxResidenceCountry: value } }) } /> }
                    </React.Fragment> }
                    { (isDetailed || isSimple || isPooled) && <React.Fragment>
                      <div className="col-5 panel-item-name">U.S. / Non-U.S. Status</div>
                      { !isEdit && <div className="col-7">{ valueOrEmpty(ownerDetails.usNonUsStatus) }</div> }
                      { isEdit && <select className="col-5 form-select" value={ details.usNonUsStatus || '' } onChange={ e => this.setState({ details: { ...details, usNonUsStatus: e.target.value } }) }>
                        <option value="">Please select</option>
                        <option>Intermediary</option>
                        <option>Foreign Person</option>
                        <option>Foreign Entity - Exempt</option>
                        <option>Foreign Entity - NonExempt</option>
                        <option>US Individual</option>
                        <option>US Entity - Exempt</option>
                        <option>US Entity - NonExempt</option>
                      </select> }
                    </React.Fragment> }
                    <div className="col-5 panel-item-name">FATCA Status</div>
                    { !isEdit && <div className="col-7">{ valueOrEmpty(getChapter4DescriptionByName(ownerDetails.fatcaStatus)) }</div> }
                    { isEdit && <select
                      className="col-5 form-select"
                      onChange={ e => this.setState({ details: { ...details, fatcaStatus: Chapter4Status.findByName(e.target.value).name || '' } }) }
                      defaultValue={ (details.fatcaStatus && details.fatcaStatus) || '' }
                    >
                      <option value="">Please select</option>
                      { Chapter4Status.filter(x => !isPooled || (isPooled && x.whsPooledStatus)).map(x => (
                        <option key={ x.value } value={ x.name }>{ x.description } - { x.value }</option>
                      )) }
                    </select> }
                    <div className="col-5 panel-item-name">Chapter 3 Recipient Code</div>
                    { !isEdit && <div className="col-7">{ valueOrEmpty(getChapter3DescriptionByName(ownerDetails.chapter3RecipientCode)) }</div> }
                    { isEdit && <select
                      className="col-5 form-select"
                      onChange={ e => this.onCh3Change(e) }
                      defaultValue={ (details.chapter3RecipientCode && details.chapter3RecipientCode) || '' }
                    >
                      <option value="">Please select</option>
                      { Chapter3Status.filter(x => !isPooled || (isPooled && x.whsPooledStatus)).map(x => (
                        <option key={ x.value } value={ x.name }>{ x.description } - { x.value }</option>
                      )) }
                    </select>}
                    { isEdit && canSetIntermediaryCheckbox && <React.Fragment>
                      <div className="col-5 panel-item-name" />
                      <div className="col-5">
                        <label className={ `form-checkbox inline ${ disableIntermediaryCheckbox ? 'tooltip' : '' }` } data-tooltip={ disabledIntermediaryToolTipText }>
                          <input
                            name="isTier"
                            type="radio"
                            value
                            checked={ details.isTier !== null && details.isTier }
                            onChange={ e => this.setState({ details: { ...details, isTier: true } }) }
                            disabled={ disableIntermediaryCheckbox }
                          />
                          <i className="form-icon" /> Intermediary
                        </label>
                        <label className={ `form-checkbox inline ${ checkboxState.formsDisableOwnerCheckbox ? 'tooltip' : '' }` } data-tooltip={ disabledOwnerToolTipText }>
                          <input
                            name="isTier"
                            type="radio"
                            value={ false }
                            checked={ details.isTier !== null && !details.isTier }
                            onChange={ e => this.setState({ details: { ...details, isTier: false } }) }
                            disabled={ checkboxState.formsDisableOwnerCheckbox }
                          />
                          <i className="form-icon" /> Owner
                        </label>
                      </div>
                    </React.Fragment>}
                  </div>
                </div>
              </div>
              { validationResultLine && <WhdValidationSummary sectionTitle={ name || 'Beneficial Owner' } validationResult={ validationResultLine } /> }
            </div>
            <div className="col-3 align-vertical-center">
              <div className="allocation-container">
                <div className="allocation-title">
                  { BeneficialOwner.getAllocationTitle() }
                </div>
                {(!isEdit || isImyLayer) && <div className="allocation-value" data-testid="label-allocation-value">
                  { this.displayAllocationValue(beneficialOwner) }%
                </div> }
                { ((isEdit && allowLayerAllocationChange) || (isEdit && !isImyLayer)) && <div>
                  <span><input className="form-input allocation-input" data-testid="field-allocation-value" type="number" value={ details.allocationIncomeRate || '' } onChange={ e => this.onIncomeAllocationChange(e) } />%</span>
                  </div> }
                { isEdit && <div className="align-vertical-center">
                  <div className="action-btn"><button className="btn btn-primary" type="button" disabled={ isSavingStatement } onClick={ () => this.submitData() }><i className="icon icon-2x icon-check" /></button></div>
                  <div className="action-btn"><button className="btn btn-secondary" type="button" disabled={ isSavingStatement } onClick={ () => this.setState({ isEdit: !isEdit }) }><i className="icon icon-2x icon-cross" /></button></div>
                </div> }
                { (!isPooled && !hideTierAllocationValue && BeneficialOwner.shouldDisplayTierAllocationValue(beneficialOwner)) && <div>
                  <div className="tier-allocation-title">
                    { BeneficialOwner.getTierAllocationTitle(beneficialOwner) }
                  </div>
                  <div className="tier-allocation-value" data-testid="field-allocation-value">
                    { this.displayTierAllocationValue(beneficialOwner, parentTierTotalAllocation) }%
                  </div>
                </div>}
                { !isEdit && <div className="align-vertical-center">
                  { hasFormUploaded && <div className="action-btn">
                    { AccessControl.hasPermission(permissions, [ActivityPerms.scannedView, ActivityPerms.scannedEdit, ActivityPerms.scannedValidate]) && <FormViewButton
                      permissions={ permissions }
                      formId={ ownerFormId }
                      form={ buildFormObject(beneficialOwnerObject.basicDetails) }
                      content={ <i className="icon icon-2x icon-apps" /> }
                      className="btn btn-secondary"
                      title="View Form"
                    /> }
                  </div> }
                  { AccessControl.hasPermission(permissions, [ActivityPerms.whdViewRates]) && isPooled && isStructureValid && <button
                    className="btn btn-secondary"
                    type="button"
                    onClick={ () => { openPooledRatesModal(pooledRecipient.guid, pooledRecipient.rates); } }
                    title="View Withholding Rates"
                    data-testid="btn-view-withholding-rates"
                  ><i className="icon icon-2x icon-calculator" /></button> }
                  { hasFormUploaded && <div className="action-btn">
                    { AccessControl.hasPermission(permissions, [ActivityPerms.scannedViewTree]) && <button
                      className="btn btn-secondary"
                      type="button"
                      onClick={ () => this.displayImy(ownerAccountId, statementVersion) }
                      title="View IMY Tree"
                    ><i className="icon icon-2x icon-treeview" /></button> }
                  </div> }
                  { canEdit && <div className="action-btn">
                    <button
                      className="btn btn-secondary"
                      type="button"
                      disabled={ isSavingStatement }
                      onClick={ () => this.setState({ isEdit: !isEdit }) }
                      title="Edit"
                      data-testid="btn-edit"
                    >
                      <i className="icon icon-2x icon-edit" />
                    </button>
                  </div> }
                  { canEdit && <div className="action-btn">
                    <button
                      className="btn btn-secondary"
                      disabled={ isDeletingRow }
                      type="button"
                      onClick={ () => this.openDeleteConfirmation() }
                      title="Delete"
                      data-testid="btn-delete"
                    >
                      <i className="icon icon-2x icon-delete" />
                    </button></div> }
                </div> }
              </div>
            </div>
            { (isDetailed || isSimple) && <div className={ `col-12 section additional-details ${ isAdditionalExpanded ? '' : 'collapsed' }` }>
              <div className="separator" />
              <div className="columns">
                <div className="col-9">
                  <div className="columns">
                    <div className="col-6">
                      <h3>Additional Address Fields</h3>
                      <div className="columns">
                        <div className="col-5 panel-item-name">Street Address</div>
                        { !isEdit && <div className="col-7">{ valueOrEmpty(ownerDetails.address) }</div> }
                        { isEdit && <input type="text" className=" col-5 form-input" onChange={ e => this.setState({ details: { ...details, address: e.target.value } }) } value={ details.address || '' } /> }
                        { isDetailed && <React.Fragment>
                          <div className="col-5 panel-item-name">City</div>
                          { !isEdit && <div className="col-7">{ valueOrEmpty(ownerDetails.city) }</div> }
                          { isEdit && <input type="text" className=" col-5 form-input" onChange={ e => this.setState({ details: { ...details, city: e.target.value } }) } value={ details.city || '' } /> }
                          <div className="col-5 panel-item-name">State / Province</div>
                          { !isEdit && <div className="col-7">{ valueOrEmpty(ownerDetails.stateProvince) }</div> }
                          { isEdit && <input type="text" className=" col-5 form-input" onChange={ e => this.setState({ details: { ...details, stateProvince: e.target.value } }) } value={ details.stateProvince || '' } /> }
                          <div className="col-5 panel-item-name">ZIP / Postal Code</div>
                          { !isEdit && <div className="col-7">{ valueOrEmpty(ownerDetails.zip) }</div> }
                          { isEdit && <input type="text" className=" col-5 form-input" onChange={ e => this.setState({ details: { ...details, zip: e.target.value } }) } value={ details.zip || '' } /> }
                          <div className="col-5 panel-item-name">Country</div>
                          { !isEdit && <div className="col-7">{ valueOrEmpty(ownerDetails.country) }</div> }
                          { isEdit && <JurisdictionDropDown value={ details.country || '' } onChange={ value => this.setState({ details: { ...details, country: value } }) } /> }
                        </React.Fragment> }
                      </div>
                    </div>
                    { isDetailed && <div className="col-6">
                      <h3>Further Details</h3>
                      <div className="columns">
                        <div className="col-5 panel-item-name">New Beneficial Owner?</div>
                        { !isEdit && <div className="col-7">{ valueOrEmpty(ownerDetails.new) }</div> }
                        { isEdit && <select className="form-select col-5" value={ details.new || '' } onChange={ e => this.setState({ details: { ...details, new: e.target.value } }) }>
                          <option value="Yes">Yes</option>
                          <option value="No">No</option>
                        </select> }
                        <div className="col-5 panel-item-name">Active Beneficial Owner?</div>
                        { !isEdit && <div className="col-7">{ valueOrEmpty(ownerDetails.active) }</div> }
                        { isEdit && <select className="form-select col-5" value={ details.active || '' } onChange={ e => this.setState({ details: { ...details, active: e.target.value } }) }>
                          <option value="Yes">Yes</option>
                          <option value="No">No</option>
                        </select> }
                        <div className="col-5 panel-item-name">U.S. TIN Type</div>
                        { !isEdit && <div className="col-7">{ valueOrEmpty(ownerDetails.tinType) }</div> }
                        { isEdit && <select className="form-select col-5" value={ details.tinType || '' } onChange={ e => this.setState({ details: { ...details, tinType: e.target.value } }) }>
                          <option value="">Please select</option>
                          <option value="SSN">SSN</option>
                          <option value="EIN">EIN</option>
                        </select> }
                        <div className="col-5 panel-item-name">Tax Form Type</div>
                        { !isEdit && <div className="col-7">{ valueOrEmpty(formType && formType.getFamilyName()) }</div> }
                        { isEdit && <select
                          className="form-select col-5"
                          value={ details.formType || '' }
                          onChange={ e => this.onFormTypeChange(e) }
                        >
                          <option value=""> Please select</option>
                          <option value={ 1 }>W-8BEN Jul-2017</option>
                          <option value={ 2 }>W-8BEN-E Apr-2016</option>
                          <option value={ 3 }>W-8IMY Sep-2016</option>
                          <option value={ 4 }>W-9 Dec-2014</option>
                          <option value={ 9 }>W-8EXP Jul-2017</option>
                          <option value={ 10 }>W-8IMY Jun-2017</option>
                          <option value={ 11 }>W-8BEN-E Jul-2017</option>
                          <option value={ 16 }>W-8ECI Feb-2014</option>
                          <option value={ 12 }>W-8ECI Jul-2017</option>
                          <option value={ 17 }>W-8EXP Sep-2016</option>
                          <option value={ 18 }>W-8BEN Feb-2014</option>
                          <option value={ 19 }>W-9 Nov-2017</option>
                          <option value={ 20 }>W-9 Oct-2018</option>
                          <option value={ 36 }>W-9 Mar-2024</option>
                          <option value={ 26 }>W-8BEN Oct-2021</option>
                          <option value={ 27 }>W-8ECI Oct-2021</option>
                          <option value={ 28 }>W-BEN-E Oct-2021</option>
                          <option value={ 29 }>W-8IMY Oct-2021</option>
                          <option value={ 37 }>W-8EXP Oct-2023</option>
                        </select> }
                      </div>
                    </div> }
                  </div>
                </div>
                { isDetailed && <div className="col-3">
                  <div className="columns pad-h3-absence">
                    <div className="col-7 panel-item-name">Treaty Benefits</div>
                    { !isEdit && <div className="col-3">{ valueOrEmpty(ownerDetails.treatyBenefits) }</div> }
                    { isEdit && <select className="form-select col-3" value={ details.treatyBenefits || '' } onChange={ e => this.setState({ details: { ...details, treatyBenefits: e.target.value } }) }>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </select> }
                    <div className="col-7 panel-item-name">Limitation on Benefits</div>
                    { !isEdit && <div className="col-5">{ valueOrEmpty(BeneficialOwner.getLOBDescriptionByCode(ownerDetails.limitationOnBenefits)) }</div> }
                    { isEdit && <select className="form-select col-4" value={ details.limitationOnBenefits || '' } onChange={ e => this.setState({ details: { ...details, limitationOnBenefits: e.target.value } }) }>
                      <option value="">Please select</option>
                      { LOBCodes.map(x => (<option key={ x.value } value={ x.value }>{ x.description }</option>)) }
                    </select> }
                  </div>
                </div> }
              </div>
            </div> }
            { (isDetailed || isSimple) && <div className="additional-details-toggle-container">
              <button type="button" className="btn additional-details-toggle-button" onClick={ this.toggleExpandedAdditionalDetails } title={ `${ isAdditionalExpanded ? 'Hide' : 'Show' } Additional Details` }>
                <span className={ `icon icon-arrow-${ isAdditionalExpanded ? 'up' : 'down' }` } />
              </button>
            </div>}
          </div>
        </div> }
      </div>
      { beneficialOwner.recipients && <div className="tier-owner-details">
        { beneficialOwner.recipients.map((x, childIdx) => <BeneficialOwner
          key={ x.guid || (x.ownerDetails && x.ownerDetails.guid) }
          id={ BeneficialOwner.buildElementId(x.name || x.ownerDetails?.name || x.basicDetails?.name) }
          beneficialOwner={ x }
          decimalPrecision={ decimalPrecision }
          getChapter3DescriptionByName={ getChapter3DescriptionByName }
          getChapter4DescriptionByName={ getChapter4DescriptionByName }
          idx={ childIdx }
          openChangeParentModal={ openChangeParentModal }
          parents={ levelParents }
          statementType={ statementType }
          isTopTierExpanded={ isTopTierExpanded }
          isParentTierExpanded={ !isTierCollapsed }
          dispatch={ dispatch }
          permissions={ permissions }
          openAccountWithholdingModal={ formId => openAccountWithholdingModal(formId) }
          topAccountId={ topAccountId }
          parentAccountId={ ownerAccountId }
          openAddFormModal={ openAddFormModal }
          addBeneficialOwner={ addBeneficialOwner }
          isSavingStatement={ isSavingStatement }
          updateToggledCollapsibleTiers={ (accountName, toggleState) => updateToggledCollapsibleTiers(accountName, toggleState) }
          tierCollapseStructure={ tierCollapseStructure }
          validationLineNo={ x.ownerDetails?.lineNo || null }
          validationResult={ validationResult }
          openPooledRatesModal={ (accountName, rates) => openPooledRatesModal(accountName, rates) }
          isDeletingRow={ isDeletingRow }
          isStructureValid={ isStructureValid }
          isAddingNewBeneficalOwner={ isAddingNewBeneficalOwner }
          statementVersion={ statementVersion }
          parentTierTotalAllocation={ BeneficialOwner.getAllocationValue(beneficialOwner) }
        />) }
      </div> }
      <ConfirmModal
        key="deleteRowConfirmation"
        isShown={ rowToDelete != null }
        isPerformingAction={ isDeletingRow }
        onConfirm={ () => this.deleteRow() }
        onCancel={ () => {
          this.closeDeleteConfirmation();
        } }
        confirmTitle="Continue"
        cancelTitle="Close"
        title="Are you sure?"
        message={ beneficialOwner?.recipients
          ? 'Deleting an intermediary will also delete all of the beneficial owners beneath it'
          : 'Deleting a statement row can not be undone' }
      />
    </React.Fragment>;
  }
}

export default BeneficialOwner;
